import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from 'react-i18next';

const CoachPaymentPage = () => {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.paypal.com/sdk/js?client-id=AdG6XwWFUDa7CESstOX2rRNYE1kG0zOThNOaiy0y-MX-uSlzehg9-j7P3RXFYQKoXQ7UHbr2h6PrztSi&vault=true&intent=subscription";
    script.addEventListener("load", () => {
      window.paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'black',
          layout: 'vertical',
          label: 'subscribe'
        },
        createSubscription: (data, actions) => {
          return actions.subscription.create({
            plan_id: 'P-8BB68556E3092192RNHACYJA'
          });
        },
        onApprove: (data) => {
          // 👇 CLAVE
          window.location.href = `/coach-success?sub=${data.subscriptionID}&token=${token}`;
        }
      }).render('#paypal-button');
    });

    document.body.appendChild(script);
  }, []);

  return (
    <div className="page-container animate-fade-in">
      <div className="header">
        <h1 className="header-title">{t('coach_payment.title')}</h1>
      </div>

      <div className="card" style={{ textAlign: "center" }}>
        <h2 style={{ color: "var(--primary)" }}>🐉 {t('coach_payment.access_title')}</h2>
        <p style={{ marginBottom: "20px" }}>
          {t('coach_payment.access_desc')}
        </p>

        <div id="paypal-button"></div>
      </div>
    </div>
  );
};

export default CoachPaymentPage;